import { Link, useSearchParams } from 'react-router-dom';
import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import './Payment.scss';

const PaymentFail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || '결제가 취소되었거나 실패했습니다.';

  return (
    <div className="payment-page">
      <Header />
      <section className="payment-section">
        <div className="container">
          <div className="payment-panel">
            <h2 className="payment-panel__title">결제에 실패했습니다</h2>
            <p className="payment-panel__desc">{message}</p>
            <Link to="/payment" className="payment-btn payment-btn--secondary">
              다시 시도하기
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PaymentFail;
